import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import axios from 'utils/axios';
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/orders/view/remove/REQUEST';
export const SUCCESS = '@app/orders/view/remove/SUCCESS';
export const FAILURE = '@app/orders/view/remove/FAILURE';
export const SET_LOADING = '@app/orders/view/remove/SET_LOADING';
export const SET_ITEMS = '@app/orders/view/remove/SET_ITEMS';
export const CLEAR = '@app/orders/view/remove/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    data: null,
    success: null
};

/**
 * Redirect route after delete enum
 */
const REDIRECT_ROUTE = {
    1: '/orders/active',
    2: '/orders/ongoing',
    3: '/orders/completed'
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                draft.data = null;
                draft.success = null;
                break;
            case SUCCESS:
                draft.data = payload.data;
                draft.loading = false;
                draft.success = true;
                break;
            case FAILURE:
                draft.loading = false;
                draft.errorStatus = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.errorStatus = '';
                draft.data = null;
                draft.success = null;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */

export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.delete(`/orders/${payload.id}`);
            yield put(actions.success(response.data));

            yield put(push(REDIRECT_ROUTE[payload.type]));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
